import styled from 'styled-components';
import { Box, Flex } from '@bigcommerce/big-design';

function getTagTextColor(tag) {
	switch (tag) {
		case 'Prefactory Followup':
			return '#027934';
		case 'Customer Service New':
			return '#947c00';
		default:
			return '#ffffff';
	}
}

function getTagBackground(tag) {
	switch (tag) {
		case 'Prefactory Followup':
			return '#d4efdf';
		case 'Followup Resolved':
			return '#26a55b';
		case 'Customer Service New':
			return '#f6efa7';
		case 'Customer Service Pending':
			return '#d16508';
		case 'Customer Service Resolved':
			return '#26a55b';
		case 'Hold Order':
			return '#d13e3e';
		case 'Hold Order Resolved':
			return '#26a55b';
		case 'Request to Cancel':
			return '#ee70bc';
		case 'Verified':
			return '#26a55b';
		case 'Factory Followup':
			return '#1878d0';
		case 'In Review':
			return '#5E48CC';
		case 'PDF Downloaded':
			return '#a345ed';
		default:
			return '#879193';
	}
}

const StyledSelectedTags = styled(Box).attrs({ className: 'selected-tags' })`
	background: ${({ tag }) => getTagBackground(tag)};
	width: max-content;
	color: ${({ tag }) => getTagTextColor(tag)} !important;
	border-radius: 2px;
	line-height: 24px;
	padding: 0 12px;
	margin: 6px;
`;

export default function OrderTagColumn({ tags }) {
	return (
		<Flex flexWrap="wrap">
			{tags.map((tag) => (
				<StyledSelectedTags tag={tag} key={tag}>
					{tag}
				</StyledSelectedTags>
			))}
		</Flex>
	);
}
